import { getPriceTriggers } from "../../../api/services/storeService";
import {
  calculateWholeOrderDiscount,
  calculatePerItemDiscount,
  matchConditions,
  getApplicablePriceTriggers,
} from "../../../api/helpers/priceTriggerHelpers";
import {
  canEarnStampForItem,
  stampDiscountableItems,
  validEarningLoyalityRoles,
} from "../../../api/helpers/LoyalityHelper.js";
import { validRedemptionRules } from "../../../api/helpers/redemptionRulesHelper.js";
import {
  OutcomeType,
  TriggerMode,
  priceTriggerType,
} from "../../../api/constants/priceTriggerEnums";
import store from "../../../store";
import {
  getCurrentDate,
  getTimeDifference,
} from "../../../api/helpers/datetimeHelper";
import { Duration } from "luxon";
export default {
  state: {
    MenuEntity: {},
  },
  mutations: {
    setPriceTriggers(state, payload) {
      if (payload) {
        state.MenuEntity = payload;
        var priceTriggers = [];
        var loyaLities = [];
        var redemptionRules = [];
        if (payload.PriceTriggers) {
          for (let key in payload.PriceTriggers) {
            priceTriggers.push({ ...payload.PriceTriggers[key] });
          }
        }
        if (payload.EarningRules) {
          for (let rule of payload.EarningRules) {
            loyaLities.push({ ...rule });
          }
        }
        if (payload.RedemptionRules) {
          for (let rule of payload.RedemptionRules) {
            redemptionRules.push({ ...rule });
          }
        }

        state.MenuEntity.PriceTriggers = priceTriggers;
        state.MenuEntity.EarningRules = loyaLities;
        state.MenuEntity.RedemptionRules = redemptionRules;
        state.MenuEntity.MenuTimeSettings = payload.MenuTimeSettings;
      } else {
        state.MenuEntity = {
          PriceTriggers: [],
          EarningRules: [],
          RedemptionRules: [],
          MenuTimeSettings: [],
        };
      }
    },
    confirmPriceTrigger(state, payload) {
      state.priceTriggerConfirms[payload] = true;
    },
  },
  actions: {
    initPriceTriggers(context, storeId) {
      getPriceTriggers(storeId).onSnapshot(async function (doc) {
        if (doc.exists) {
          context.commit("setPriceTriggers", doc.data());
          context.dispatch("applyPriceTriggers");
        }
      });
    },
    fixRollIntoQuantity(context) {
      context.state.MenuEntity.PriceTriggers.forEach((pt) => {
        var outcomeType = pt.OutcomeType;
        if (outcomeType && outcomeType >= 0) {
          for (const condition of pt.ProductCategoryConditions) {
            var totalAccur = 0;
            context.getters.cartItems.forEach((item) => {
              if (item.ProductCategoryIDs.includes(condition.ProductCategoryID))
                totalAccur += item.quantity;
            });
            var couldChoose = Math.floor(totalAccur / condition.Quantity);
            var selectedRollIntosQuantity = 0;
            context.getters.getPriceTriggerOutcomes
              .filter((p) => p.ID == pt.ID)
              .forEach((spt) => {
                var count = spt.selectedRollIntos
                  ? spt.selectedRollIntos.length
                  : 0;
                while (selectedRollIntosQuantity + count > couldChoose) {
                  spt.selectedRollIntos.pop();
                  count--;
                }
                selectedRollIntosQuantity += count;
              });
          }
          context.dispatch("applyPriceTriggers");
        }
      });
    },
    fixRedemptionQuantity(context) {
      while (
        context.getters.reedemptionLocalUsedPoints >
          context.getters.reedemptionPoints &&
        context.getters.reedemptionPoints >= 0
      ) {
        var cartItem = {
          ...context.getters.cartItems.find((p) => p.reedemptionRule),
        };
        context.commit("REMOVE_CART_ITEM", { item: cartItem });
      }
    },
  },
  getters: {
    getProductOutcomeInfo: (state, getters) => (productId) => {
      var product = getters.getProductById(productId);
      return product;
    },
    getProductInCategoryInfo: (state, getters) => (productId) => {
      for (var i = 0; i < getters.storeMenu.Categories.length; i++) {
        var p = getters.storeMenu.Categories[i];
        var subMenuItem = p.SubMenuItems.find((p) => p.ProductID == productId);
        if (subMenuItem) {
          subMenuItem.categoryId = p.ID;
          subMenuItem.categoryName = p.Name;
          return subMenuItem;
        }
      }
    },
    apllicablePriceTriggers: (state, rootState) => (predictItem) => {
      let isNewUser = false;
      if (rootState.dbuser && rootState.dbuser.IsNewUser === true) {
        isNewUser = true;
      }
      if (!state.MenuEntity.PriceTriggers) return [];
      let cartItems = [...(rootState.cartItems || [])];
      if (predictItem) {
        cartItems = [predictItem];
      }
      return getApplicablePriceTriggers(
        cartItems,
        state.MenuEntity.PriceTriggers,
        isNewUser,
        rootState.used_coupons.length > 0,
        rootState.cartValue,
        rootState.currentStoreDoc
          ? rootState.currentStoreDoc.TimezoneIanaFormat
          : null
      );
    },
    canshowRollInto:
      (state, getters) =>
      (orderItem, addQuantity = 0) => {
        var chooses = getters.getPriceTriggerOutcomes;
        if (!state.MenuEntity.PriceTriggers) return null;
        var priceTriggers = state.MenuEntity.PriceTriggers.filter(
          (p) => !p.IsDisabled
        );
        for (const priceTrigger of priceTriggers) {
          var outcomeType = priceTrigger.OutcomeType;
          if (!outcomeType) {
            continue;
          }
          if (outcomeType >= 0) {
            //meet conditions
            var selectedRollIntosQuantity = 0;
            chooses
              .filter((p) => p.ID == priceTrigger.ID)
              .forEach((pt) => {
                selectedRollIntosQuantity += pt.selectedRollIntos
                  ? pt.selectedRollIntos.length
                  : 0;
              });
            var match = matchConditions(
              priceTrigger,
              orderItem,
              getters.cartItems,
              selectedRollIntosQuantity || 0,
              addQuantity
            );
            if (!match) {
              continue;
            } else if (matchConditions) {
              if (outcomeType == OutcomeType.OutcomeType_Products) {
                if (
                  priceTrigger.TriggerMode == TriggerMode.TriggerWithConfirm &&
                  priceTrigger.IsOutcomeLinkedToProduct == true
                ) {
                  if (priceTrigger.ProductOutcomes.length) {
                    return {
                      ...priceTrigger,
                      ProductID: priceTrigger.ProductOutcomes[0].ProductID,
                      appliedDiscount: priceTrigger.FixedPriceValue,
                    };
                  } else {
                    continue;
                  }
                }
              }
            }
          }
        }
      },
    //calculate results
    getPriceTriggerOutcomes(state, getters) {
      let outcomes = [];
      let totalDiscount = 0;
      for (let pt of getters.apllicablePriceTriggers()) {
        if (pt.type == priceTriggerType.perCategoryDiscountPriceTriggers) {
          let orderItems = [];
          let appliedFor = '';
          let discountMultiplyBy = 1;
          if (pt.ProductCategoryConditions.length) {
            for (const condition of pt.ProductCategoryConditions) {
              const categoryID = condition.ProductCategoryID;
              // check if price trigger is already applied for this category
              const apt = outcomes.find(pt => pt.appliedFor === categoryID)
              if (!apt) {
                orderItems = getters.cartItems.filter((p) => p.ProductCategoryIDs.includes(categoryID));
                if (orderItems.length) {
                  const quantity = orderItems.reduce((total, orderItem) => total + orderItem.quantity, 0);
                  if(quantity >= condition.Quantity) {
                    discountMultiplyBy = pt.RunType === 2 ? Math.floor(quantity / condition.Quantity) : 1;
                    appliedFor = categoryID;
                  }
                }
              }
            }
          }
          if (pt.ProductTagConditions.length) {
            for (const condition of pt.ProductTagConditions) {
              const tagID = condition.ProductTagID;
              // check if price trigger is already applied for this tag
              const apt = outcomes.find(pt => pt.appliedFor === tagID)
              if (!apt) {
                orderItems = getters.cartItems.filter((p) => p.ProductTagIDs.includes(tagID));
                if (orderItems.length ) {
                  const quantity = orderItems.reduce((total, orderItem) => total + orderItem.quantity, 0);
                  if(quantity >= condition.Quantity) {
                    discountMultiplyBy = pt.RunType === 2 ? Math.floor(quantity / condition.Quantity) : 1;
                    appliedFor = tagID;
                  }
                }
              }
            }
          }

          if (appliedFor) {
            const cheapestItem = orderItems.reduce((min, item) => (item.price < min.price ? item : min), orderItems[0]);
            let perItemOrderDiscount = calculatePerItemDiscount(pt, cheapestItem);
            totalDiscount += perItemOrderDiscount;
            outcomes.push({
              ...pt,
              appliedDiscount: perItemOrderDiscount * discountMultiplyBy,
              appliedFor,
            });
          }
        }
        else if (pt.type == priceTriggerType.perItemDiscountPriceTriggers) {
          //TODO:per item dicount
          let orderitem = getters.cartItems.find((p) => p.uniqueId == pt.order);
          if (orderitem) {
            let perItemOrderDiscount = calculatePerItemDiscount(pt, orderitem);
            totalDiscount += perItemOrderDiscount;
            outcomes.push({
              ...pt,
              appliedDiscount: perItemOrderDiscount,
            });
          }
        } else if (
          pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
        ) {
          let wholeOrderDiscount = calculateWholeOrderDiscount(
            pt,
            getters.cartValue - getters.reedemptionValue,
            totalDiscount,
            getters.priceTriggerOutcomes
          );
          outcomes.push({
            ...pt,
            appliedDiscount: wholeOrderDiscount,
          });
        } else if (pt.type == priceTriggerType.rollIntoMealPriceTriggers) {
          let find = store.getters.priceTriggerOutcomes.find(
            (oc) => oc.order == pt.order && oc.ID == pt.ID
          );
          let selectedRollIntos = null;
          if (find) {
            selectedRollIntos = JSON.parse(
              JSON.stringify(find.selectedRollIntos)
            );
            if (selectedRollIntos)
              selectedRollIntos
                .filter((p) => p.isConfirmed && p.selectedModifiers)
                .forEach((rollInto) => {
                  rollInto.appliedDiscount = pt.FixedPriceValue;
                  rollInto.selectedModifiers.forEach((md) => {
                    rollInto.appliedDiscount += md.Price;
                  });
                });
          }
          outcomes.push({
            ...pt,
            selectedRollIntos,
            rollIntoProduct: {
              ...getters.getProductById(pt.ProductOutcomes[0].ProductID),
              ProductID: pt.ProductOutcomes[0].ProductID,
            },
          });
        }
      }
      return outcomes;
    },
    applicableLoyalityRule(state, getters, rootState) {
      if (!state.MenuEntity.EarningRules || !getters.user) return [];

      var LoyalityRolls = validEarningLoyalityRoles(
        state.MenuEntity.EarningRules,
        rootState.currentStoreDoc
          ? rootState.currentStoreDoc.TimezoneIanaFormat
          : null
      );
      return LoyalityRolls.sort((a, b) => {
        return b.DollarSpent - a.DollarSpent;
      });
    },

    getFirstValidRedemptionRule: (state, getters) => {
      if (getters.enableStamps) {
        return null;
      }
      if (!state.MenuEntity.RedemptionRules) {
        return null;
      }
      let userPoints =
        getters.dbuser && getters.dbuser.RewardPoints
          ? getters.dbuser.RewardPoints
          : 0;

      var validRule = validRedemptionRules(
        state.MenuEntity.RedemptionRules,
        getters.currentStoreDoc
          ? getters.currentStoreDoc.TimezoneIanaFormat
          : null,
        getters.cartValue,
        userPoints,
        getters.reedemptionLocalUsedPoints,
        getters.storeMenu,
        getters.cartItems
      );

      return validRule;
    },

    storeSupportsLoyaltyPoints: (state, getters) => {
      return (
        !getters.enableStamps &&
        (getters.getFirstValidRedemptionRule !== null ||
          getters.getMenuEntity.PointsToDollarRatio > 0) &&
        getters.applicableLoyalityRule.length > 0
      );
    },

    storeSupportEarningLoyaltyPoints: (state, getters) => {
      return getters.applicableLoyalityRule ? getters.applicableLoyalityRule.length : 0;
    },

    getMenuEntity(state) {
      return state.MenuEntity;
    },

    getMenuTimeSettings(state, getters) {
      if (!getters.currentStoreDoc) {
        return null;
      }
      let menuTS = [...(state.MenuEntity.MenuTimeSettings || [])];
      let tz = getters.currentStoreDoc.TimezoneIanaFormat;
      let now = getCurrentDate(getters.currentStoreDoc ? tz : null);
      menuTS = menuTS.map((ts) => {
        return {
          ...ts,
          StartTime:
            ts.StartTime.length < 6 ? ts.StartTime + ":00" : ts.StartTime,
          EndTime: ts.EndTime.length < 6 ? ts.EndTime + ":00" : ts.EndTime,
        };
      });
      menuTS = menuTS.sort((a, b) => {
        return getTimeDifference(a.StartTime, b.StartTime);
      });
      let delivarableDates = [now];
      let deliverableDays = [];
      const numberOfPreorderDays = 4;
      let candidates = [];

      for (let i = 1; i < numberOfPreorderDays; i++) {
        delivarableDates.push(now.plus({ day: i }));
      }
      for (const dt of delivarableDates) {
        let day = dt.weekday == 7 ? 0 : dt.weekday;
        deliverableDays.push(day);
        let tss = menuTS.filter((ts) => ts.DayOfWeek == day);
        for (const ts of tss) {
          let duration = Duration.fromISOTime(ts.StartTime);
          candidates.push({
            ...ts,
            dateTime: dt.set({
              hour: duration.hours,
              minute: duration.minutes,
              second: duration.seconds,
            }),
          });
        }
      }
      return candidates;
    },
    getMenuLifeStyles(state) {
      return state.MenuEntity.LifeStyleChoices;
    },
    enableStamps(state, getters) {
      return (
        getters.stampsSettings && getters.stampsSettings.Enabled && getters.user
      );
    },
    stampsSettings(state, getters) {
      if (
        getters.selectedCompany &&
        getters.selectedCompany.LoyaltyStampSettings
      ) {
        return getters.selectedCompany.LoyaltyStampSettings;
      }
      return null;
    },
    userStamps(state, getters) {
      return parseInt(
        (getters.dbuser || null).RewardPoints ? getters.dbuser.RewardPoints : 0
      );
    },
    collectableStamps(state, getters) {
      let sum = 0;
      getters.cartItems.forEach((item) => {
        sum += getters.itemStamps(item);
      });
      return sum;
    },
    redeemedStamps(state, getters) {
      if (getters.enableStamps && getters.stampAppliedItems.length > 0) {
        return getters.stampsSettings.StampsBuy || 0;
      }
      return 0;
    },
    stampAppliedItems(state, getters) {
      if (getters.enableStamps) {
        const candidates = stampDiscountableItems(
          getters.stampsSettings,
          getters.cartItems,
          getters.userStamps
        );
        // first release just apply discount to one item
        return candidates.slice(0, 1);
      }
      return [];
    },
    stampsDiscount(state, getters) {
      return getters.stampAppliedItems.reduce(
        (acc, value) => acc + value.price,
        0
      );
    },

    itemStamps: (state, getters) => (item) => {
      if (
        canEarnStampForItem(
          getters.stampsSettings,
          getters.currentStoreDoc.TimezoneIanaFormat,
          item
        )
      ) {
        const find = getters.stampAppliedItems.find((d) => (d.id = item.id));
        if (find && find.quantity == 1) {
          return 0;
        }
        if (find && find.quantity > 1) {
          return find.quantity - 1;
        }
        return item.quantity;
      }
      return 0;
    },
    loyaltyUnit: (state, getters) => (value) => {
      if (getters.enableStamps) {
        if (value == 1) return "stamp";
        if (value > 1) return "stamps";
      } else {
        return "points";
      }
    },
  },
};
